import * as React from 'react';
import * as styles from './navigation.module.scss';
import SimpleOutlinedInput from '../../../common/simpleOutlinedInput';
import Navigation from '../../../../models/navigation';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import { ListItem, ListItemIcon, List, IconButton, ListItemSecondaryAction } from '@material-ui/core';
import DashListItem from './dashListItem';
import { DraggableProvided, Droppable, Draggable } from 'react-beautiful-dnd';
import clsx from 'clsx';
import Dashboard from '../../../../models/Dashboard';
import { Delete } from '@material-ui/icons';
import ConfirmationModal from '../../../report/customViewModal/confirmationModal';
import ConfirmationDialog from '../../../common/confirmationDialog';

interface Props {
  navigation: Navigation;
  provided: DraggableProvided;
  clientDashboards: Dashboard[];
  updateDashboardNavigation: (navigation: Navigation) => void;
  updateCategoryNavigation: (navigation: Navigation) => void;
  deleteCategory: (navigationId: number) => void;
  deleteDashboard: (navigation: Navigation) => void;
}

/**
 * Component that contains a category item, along with it's associated dashboard items
 */
const CateogryListItem = ({
  navigation,
  provided,
  clientDashboards,
  updateDashboardNavigation,
  updateCategoryNavigation,
  deleteCategory,
  deleteDashboard
}: Props) => {
  const [categoryInputValue, setCategoryInputValue] = React.useState<string>(navigation.name);
  const [modalOpen, setModalOpen] = React.useState(false);

  const addCategoryHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (categoryInputValue) {
      updateCategoryNavigation({ ...navigation, name: categoryInputValue });
    }
  };

  const deleteCategoryHandler = () => {
    if (navigation.children.length > 0) {
      setModalOpen(true);
    } else {
      deleteCategory(navigation.navigationId);
    }
  };
  const deleteOnConfirmation = () => {
    deleteCategory(navigation.navigationId);
    setModalOpen(false);
  };

  return (
    <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
      <ListItem className={styles.navListItem}>
        <ConfirmationModal
          open={modalOpen}
          closeModal={() => {}}
          children={
            <ConfirmationDialog
              title="Confirmation"
              message="Are you sure you want to delete this category and all of its dashboards?"
              confirmAction={deleteOnConfirmation}
              cancelAction={() => setModalOpen(false)}
            />
          }
        />
        <ListItemIcon className={styles.navListDragIcon}>
          <DragHandleIcon />
        </ListItemIcon>{' '}
        <form className={styles.navListForm} onSubmit={event => addCategoryHandler(event)}>
          <SimpleOutlinedInput
            label="Name"
            value={categoryInputValue}
            onChange={(event: any) => setCategoryInputValue(event.target.value)}
            onBlur={() => setCategoryInputValue(navigation.name)}
          />
          <ListItemSecondaryAction>
            <IconButton title="Delete" onClick={deleteCategoryHandler} edge="end" aria-label="delete">
              <Delete style={{ color: '#006da8' }} />
            </IconButton>
          </ListItemSecondaryAction>
        </form>
      </ListItem>
      <Droppable droppableId={`${navigation.navigationId}`} type="DASHBOARD">
        {(provided, snapshot) => (
          <List
            className={clsx(styles.dashboardList, snapshot.isDraggingOver && styles.isDraggingOver)}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {navigation.children.map(child => (
              <Draggable draggableId={`${child.navigationId}`} index={child.seqOrder} key={child.navigationId}>
                {provided => (
                  <DashListItem
                    childNavigation={child}
                    provided={provided}
                    clientDashboards={clientDashboards}
                    updateDashboardNavigation={updateDashboardNavigation}
                    deleteDashboard={deleteDashboard}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </List>
        )}
      </Droppable>
    </div>
  );
};

export default CateogryListItem;
